// services/FacultyService.js
import api from "../utils/axios";
import { ENDPOINTS } from "../utils/endpoints";

// LIST (paginated)
export function getFaculties(params = {}) {
    return api.get(ENDPOINTS.FACULTIES.BASE, { params });
}

// GET ONE
export function getFacultyById(id) {
    return api.get(ENDPOINTS.FACULTIES.BY_ID(id));
}

// CREATE
export function createFaculty(payload) {
    return api.post(ENDPOINTS.FACULTIES.BASE, payload);
}

// UPDATE
export function updateFaculty(id, payload) {
    return api.patch(ENDPOINTS.FACULTIES.BY_ID(id), payload);
}

// DELETE (soft delete)
export function deleteFaculty(id) {
    return api.delete(ENDPOINTS.FACULTIES.BY_ID(id));
}

// RESTORE
export function restoreFaculty(id) {
    return api.post(`${ENDPOINTS.FACULTIES.BY_ID(id)}/restore`);
}
